import * as mutationTypes from '@/store/mutation-types.js'
import stringOperations from '@/mixins/string-operations'
import dateOperations from '@/mixins/date-operations'
import icons from '@/mixins/icons.js'
import * as globalMutationTypes from '@/store/mutation-types.js'

export default {
  name: 'GebruikerAangemaakt',

  mixins: [stringOperations, dateOperations, icons],

  data() {
    return {
      debugging: this.$store.state.debugging
    }
  },

  computed: {

  },

  mounted: function () {
    let self = this
    this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
      left: [],
      title: 'Schoolware - Gebruiker aangemaakt',
      right: []
    })

    this.$store.commit(globalMutationTypes.SHOW_MESSAGE, ['Gebruiker aanmaken geslaagd! Je wordt nu doorverwezen naar de Schoolware startpagina.', 'long'])
    setTimeout(function () {
      // window.location.href = window.location.href.split('/vue/')[0] + '/start.html'
      self.$router.push('/')

    }, 3000)

  },

  methods: {



  }
}
